import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

export async function listRtoRecords(filters = {}) {
  const p = {};
  if (filters.date_from) p.date_from = filters.date_from;
  if (filters.date_to)   p.date_to   = filters.date_to;
  if (filters.offset != null) p.offset = filters.offset;
  if (filters.limit != null)  p.limit  = filters.limit;
  const res = await axios.get(`${API}/rto-records`, { headers: authHeader(), params: p });
  return res.data;
}

export async function getRtoPack(uid) {
  const res = await axios.get(`${API}/rto-records/${encodeURIComponent(uid)}/pack`, {
    headers: authHeader(),
  });
  return res.data;
}

export async function saveRtoFeedback(uid, body) {
  const res = await axios.post(`${API}/rto-records/${encodeURIComponent(uid)}`, body, {
    headers: authHeader(),
  });
  return res.data;
}
